import { axios } from '@/utils/request'

const api = {
  getUserOnlineSubCodeEncry: '/sso/subject/getUserOnlineSubCodeEncry'
}

export default api
export const getUserOnlineSubCodeEncry = params => axios.post(api.getUserOnlineSubCodeEncry, params)
